import Vue from 'vue'
import VeeValidate from 'vee-validate'
import App from './App.vue'
import store from './store'
import router from './router'
import * as jquery from 'jquery'
import VueProgressBar from 'vue-progressbar'
import BootstrapVue from 'bootstrap-vue'
import VueTheMask from 'vue-the-mask'
import VueSweetalert2 from 'vue-sweetalert2'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'sweetalert2/dist/sweetalert2.min.css'
// import 'admin-lte/dist/css/adminlte.min.css'
import 'bootstrap/dist/js/bootstrap'
import './assets/styles.css'




Vue.prototype.jquery = jquery
Vue.use(VueSweetalert2)
Vue.use(BootstrapVue)
Vue.use(VueTheMask)
Vue.use(VeeValidate)


Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
